import { LogObject, editorComponentsComponentEditedParams, editorComponentsComponentEditedSrc38Evid1399Params, pagesPanelUpdateMenuMessageActionParams, pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params } from '../types';

/**
 * A function to create a log object for the 'pagesPanelUpdateMenuMessageAction' event (evid: 2)
 *
 * Event description: Pages panel : update menu message -  action
 *
 * @param {pagesPanelUpdateMenuMessageActionParams} params - The parameters for this event
 * @property {string} action - view/hover/click
 * @property {number} num_of_pages - number of pages
 * @property {number} num_of_hidden_pages - number of hidden pages
 * @property {string} panelType - manage panel/site pages
 * @return {LogObject<pagesPanelUpdateMenuMessageActionParams>} LogObject<pagesPanelUpdateMenuMessageActionParams>
 */
export function pagesPanelUpdateMenuMessageAction(params: pagesPanelUpdateMenuMessageActionParams): LogObject<pagesPanelUpdateMenuMessageActionParams> {
  return { evid: 2, src: 38, endpoint: '', params };
}

/**
 * A function to create a log object for the 'pagesPanelUpdateMenuMessageDisplaySrc38Evid4' event (evid: 4)
 *
 * Event description: Flag for a logged_user having an old menu going to new menu with the following conditions applied:
 * - having old horizontal menu
 * - having at least 1 sub menu
 * - user clicks on "manage menu" > "Add Menu Item"  (or through manage pages panel)
 *
 * @param {pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params} params - The parameters for this event
 * @property {string} panelType - manage panel/site pages
 * @return {LogObject<pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params>} LogObject<pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params>
 */
export function pagesPanelUpdateMenuMessageDisplaySrc38Evid4(params: pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params): LogObject<pagesPanelUpdateMenuMessageDisplaySrc38Evid4Params> {
  return { evid: 4, src: 38, endpoint: '', params };
}

/**
 * A function to create a log object for the 'editorComponentsComponentEditedSrc38Evid1399' event (evid: 1399)
 *
 * Event description: Editor Components: Component Edited
 *
 * @param {editorComponentsComponentEditedSrc38Evid1399Params} params - The parameters for this event
 * @property {string} measure - measure
 * @property {boolean} is_rollout - is_rollout
 * @property {string} workspace_mode - workspace_mode
 * @property {string} jsHeapSizeLimit - jsHeapSizeLimit
 * @property {string} dm_version - dm_version
 * @property {string} multilingual - multilingual
 * @property {boolean} isSection - isSection
 * @property {string} focused_page_id - focused_page_id
 * @property {string} state - state
 * @property {GUID} site_id - {site_id
 * @property {string} control_id - setting name (as example we can use 38:365): it should be some identifier of control (setting), example: Social_Bar_Layout__Icon_Size
 * @property {boolean} isDraft - is_draft
 * @property {number} ts - ts
 * @property {boolean} isZoomOut - isZoomOut
 * @property {string} control_type - dropdown/checkbox/slider/toggle/thumbnail/text input
 * @property {string} viewmode - viewmode
 * @property {string} stage_type - stage_type
 * @property {string} page_id - page_id
 * @property {string} prev_value - which value were selected
 * @property {string} ds_origin - ds_origin
 * @property {string} totalJsHeapSize - totalJsHeapSize
 * @property {boolean} isSg - is_sg
 * @property {boolean} isSiteCreation - isSiteCreation
 * @property {string} viewerVersion - viewerVersion
 * @property {string} viewerName - viewerName
 * @property {string} new_value - which value user selected (if it numeric -> cast to str), if it check box we will send set of selected values *specifically for text input - debounce
 * @property {string} usedJsHeapSize - usedJsHeapSize
 * @property {string} editor_version - editor_version
 * @property {string} editor_working_mode - editor_working_mode
 * @property {string} panel_type - layout/settings/manage/behaviors/..
 * @property {boolean} is_valid - false - if user get validation error
 * @property {GUID} esi - esi
 * @property {string} component_id - component_id
 * @property {string} component_type - component_type
 * @property {GUID} msid - msid
 * @property {string} action_type - edit/duplicate/drag/delete
 * @property {string} sub_panel_name - the name of the sub panel
 * @return {LogObject<editorComponentsComponentEditedSrc38Evid1399Params>} LogObject<editorComponentsComponentEditedSrc38Evid1399Params>
 */
export function editorComponentsComponentEditedSrc38Evid1399(params: editorComponentsComponentEditedSrc38Evid1399Params): LogObject<editorComponentsComponentEditedSrc38Evid1399Params> {
  return { evid: 1399, src: 38, endpoint: '', params };
}

/**
 * A function to create a log object for the 'editorComponentsComponentEdited' event (evid: 1399)
 *
 * Event description: Editor Components: Component Edited
 *
 * @param {editorComponentsComponentEditedParams} params - The parameters for this event
 * @property {string} multilingual - multilingual
 * @property {string} builderType - builder_type
 * @property {number} active_uniq_page_users - active_uniq_page_users
 * @property {string} browserVW - browser_vw
 * @property {string} breakpointName - breakpoint_name
 * @property {string} state - the state of the panel
 * @property {string} ancestors - ancestors
 * @property {string} control_id - setting name (as example we can use 38:365): it should be some identifier of control (setting), example: Social_Bar_Layout__Icon_Size
 * @property {GUID} uuid - uuid
 * @property {boolean} isLiveEditor - is_live_editor
 * @property {boolean} isDraft - is_draft
 * @property {string} loadType - load_type
 * @property {string} action_context - action_context
 * @property {number} usersOnPageCount - users_on_page_count
 * @property {string} control_type - dropdown/checkbox/slider/toggle/thumbnail/text input
 * @property {number} uniqueUsersOnPageCount - unique_users_on_page_count
 * @property {string} page_id - page_id
 * @property {string} prev_value - which value were selected
 * @property {boolean} isTemplate - is_template
 * @property {string} pageId - page_id
 * @property {number} active_uniq_site_users - active_uniq_site_users
 * @property {string} referral - referral
 * @property {string} dmVersion - dm_version
 * @property {string} viewerVersion - viewer_version
 * @property {number} screenWidth - screen_width
 * @property {boolean} isContentMode - is_content_mode
 * @property {string} devMode - dev_mode
 * @property {string} viewerName - viewer_name
 * @property {string} new_value - which value user selected (if it numeric -> cast to str), if it check box we will send set of selected values *specifically for text input - debounce measure	string	px/rgb/sec... null if nut have type
 * @property {number} breakpointMin - breakpoint_min
 * @property {number} screenHeight - screen_height
 * @property {string} panel_type - layout/settings/manage/behaviors/..
 * @property {string} pageType - page_type
 * @property {string} pageName - page_name
 * @property {number} numOfPages - num_of_pages
 * @property {number} breakpointMax - breakpoint_max
 * @property {boolean} is_valid - false - if user get validation error
 * @property {number} uniqueUsersOnSiteCount - unique_users_on_site_count
 * @property {GUID} esi - esi
 * @property {string} component_id - component_id
 * @property {number} usersOnSiteCount - users_on_site_count
 * @property {string} component_type - component_type
 * @property {GUID} msid - msid
 * @property {string} action_type - edit/duplicate/drag/delete
 * @property {string} sub_panel_name - sub panel name
 * @property {string} canvasWidth - canvas_width
 * @return {LogObject<editorComponentsComponentEditedParams>} LogObject<editorComponentsComponentEditedParams>
 */
export function editorComponentsComponentEdited(params: editorComponentsComponentEditedParams): LogObject<editorComponentsComponentEditedParams> {
  return { evid: 1399, src: 110, endpoint: '', params };
}
